import { GetSuppliesParams } from "./supply.type";

export const SUPPLY_KEYS = {
  SUPPLIES: "SUPPLIES",
  SUPPLIE: "SUPPLIE",
  GET_SUPPLIES: (params?: GetSuppliesParams) => [SUPPLY_KEYS.SUPPLIES, params],
  GET_SUPPLY: (id: string) => [SUPPLY_KEYS.SUPPLIE, id],
  GET_SERVICE_TICKET_SUPPLIES: (serviceTicketId: string) => [
    `${SUPPLY_KEYS.SUPPLIES}/service-ticket`,
    serviceTicketId,
  ],
};
